// removed by extract-text-webpack-plugin
module.exports = {"ui":"link_ui_4j5a8f","linkIcon":"link_linkIcon_92gyu5","copy":"link_copy_dmpdce"};


//////////////////
// WEBPACK FOOTER
// ./packages/lib-ui/src/input/link/link.scss
// module id = 552
// module chunks = 0